import { render, staticRenderFns } from "./SectionsList.vue?vue&type=template&id=51f2f27e&scoped=true"
import script from "./SectionsList.vue?vue&type=script&lang=ts"
export * from "./SectionsList.vue?vue&type=script&lang=ts"
import style0 from "./SectionsList.vue?vue&type=style&index=0&id=51f2f27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2f27e",
  null
  
)

export default component.exports